<template>
	<div class="w-full">
		<label class="block text-md lg:text-lg">
			{{ label }}
		</label>
		<input
			:value="modelValue"
			@input="$emit('update:model', $event.target.value)"
			:type="secure ? 'password' : 'text'"
			class="block w-full bg-white border border-green-400 rounded-lg py-1 px-2 h-8"
		/>
	</div>
</template>

<script>
export default {
	name: 'TextInput',
	props: {
		label: {
			type: String,
			default: 'Label',
		},
		modelValue: {
			type: String,
			default: '',
		},
		secure: {
			type: Boolean,
			default: false,
		},
	},
	emits: [
		'update:model'
	],
};
</script>